import { get, includes } from 'lodash';

const OneTrust = class {
  static get isOneTrustActive() {
    return get(window, ['ALLBIRDS', 'isOneTrustActive'], false);
  }

  static get hasPerformanceConsent() {
    return !OneTrust.isOneTrustActive || includes(window.OnetrustActiveGroups, 'C0002');
  }

  static get hasFunctionalConsent() {
    return !OneTrust.isOneTrustActive || includes(window.OnetrustActiveGroups, 'C0003');
  }

  static get hasTargetingConsent() {
    return !OneTrust.isOneTrustActive || includes(window.OnetrustActiveGroups, 'C0004');
  }
};

export default OneTrust;
